import { postWrapperWeb } from "../utils/Wrapper";

export const verifyUser = async (data) => {
  let url = "/send-otp";
  return postWrapperWeb(url, data);
};

export const OtpVerify = async (data) => {
  let url = "/otp-verify";
  return postWrapperWeb(url, data);
};

export const leadGeneration = async (data) => {
  let url = "/api/leads";
  return postWrapperWeb(url, data);
};

export const notify = async (data) => {
  let url = "/api/notify";
  return postWrapperWeb(url, data);
};
